import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import { SimpleAsyncButton } from '@ynap/button';
import { Link } from '@ynap/router';

const bem = new BEMHelper('ProductListLayout');

type MoreButtonProps = {
    type: string;
    loading: boolean;
    copy: string;
    onClick: (previous: boolean | undefined, customPageSize: number) => unknown;
};

type LoadMoreButtonProps = {
    copy: string;
    moreButtonProps: MoreButtonProps;
    nextPageLink: string;
    percentage: number;
    prevent: () => void;
};

const LoadMoreButton = ({ copy, moreButtonProps, nextPageLink, percentage, prevent }: LoadMoreButtonProps) => {
    return (
        <div className={bem('loadMore')}>
            <p className={bem('productsViewed')}>{copy}</p>
            <div className={bem('progress')}>
                <div className={bem('bar')} style={{ width: `${percentage}%` }} />
            </div>
            <Link to={nextPageLink} onClick={prevent}>
                <SimpleAsyncButton containerClass={bem('loadMoreCTA')} className={bem('loadMoreButton')} {...moreButtonProps} />
            </Link>
        </div>
    );
};

export default LoadMoreButton;
